import CustomSelectView from '@/js/desktop/components/customSelect/CustomSelect';

export default class extends CustomSelectView {
    updateDefaultsValue(options = {}) {
        this.viewModel.set({ labelTitle: 'Город вылета:' });
        this.viewModel.set({ defaultLabelValue: 'Ищем' });
        this.openCallback = options.openCallback;
    }
}